import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import CommunityAmenities from './CommunityAmenities';
import CommunityStructure from './CommunityStructure';
import './CommunityOnboarding.css';

const CommunityOnboarding = ({
  siteId,
  siteName,
  onBack,
  onComplete,
  isSidebar = true,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const step = searchParams.get('step') === 'amenities' ? 'amenities' : 'structure';
  const [siteData, setSiteData] = useState(null);

  useEffect(() => {
    if (step === 'structure') {
      setSiteData(null);
    }
  }, [step]);

  const goToAmenities = data => {
    setSiteData(data);
    setSearchParams({ step: 'amenities' }, { replace: false });
  };

  const goToStructure = () => {
    setSearchParams({}, { replace: false });
  };

  if (step === 'amenities' && siteData) {
    return (
      <CommunityAmenities
        siteData={siteData}
        siteName={siteName}
        onBack={goToStructure}
        onComplete={onComplete}
        isSidebar={isSidebar}
      />
    );
  }

  return (
    <CommunityStructure
      siteId={siteId}
      siteName={siteName}
      onBack={onBack}
      onContinue={goToAmenities}
      isSidebar={isSidebar}
    />
  );
};

export default CommunityOnboarding;
